import { createBrowserRouter, RouterProvider } from "react-router";
import { routes } from "./router";

const router = createBrowserRouter(routes);

const App = () => {
  return (
    <main>
      <RouterProvider router={router} />
    </main>
  );
};

export default App;
